export enum Feature {
  NONE_OR_NOT_SPECIFIED = 0,
  POLLWORKER_TRAINING = 100,
  PW_TIME_CLOCK = 101,
  EASY_ORDER = 102,
  MODERN_REPORTS = 103,
  MODERN_POLLWORKER = 104,
  MODERN_CAMPAIGN_FINANCE = 105,
  MODERN_INVENTORY = 106,
  MODERN_POLLWORKER_SCHEDULER = 107,
  ATLANTA_ETHICS_DOCUMENT_FILINGS_REPORT = 108,
  MODERN_WEBUI = 109,
  POLLWORKER_LMS = 110,
}

export default Feature;
